import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss'],
  standalone: true,
  imports: [NgStyle],
})
export class ProgressCircleComponent {
  @Input() size: number = 32;
  @Input() loadingSize: number = 2;
  @Input() percent: number = 64;
  @Input() loadingColor: string = 'green';

  percentageToDegrees(percentage: number, maxDegrees: number): number {
    percentage = Math.min(100, Math.max(0, percentage));
    let degrees = (percentage / 100) * 360;
    if (degrees >= maxDegrees) degrees = maxDegrees;
    return degrees;
  }
}
